export const smartDeployBrand = {
  colors: {
    brightBlue: '#1E88FF',
    brightBlueLight: '#63ADFF',
    brightBlueDark: '#0067D6',
    deepNavy: '#0D1B2A',
    deepNavyDark: '#07111D',
    steelGray: '#5B6B7C',
    lightGray: '#E6EAF0',
    white: '#FFFFFF',
  },
  name: 'SmartDeploy',
  tagline: 'Deploy Smarter. Deliver Faster.',
};
